<script lang="ts">
	import { fade } from "svelte/transition";
	import { tick } from "svelte";
	import { writable } from "svelte/store";
	import { usePopper } from "./usePopper";

	let popperRef = writable<HTMLElement>();

	let yValue = 0;
	let xValue = 0;

	const popperPosition = writable("right");

	function calculatePosition(target: HTMLElement) {
		if ($popperRef) {
			$popperPosition = "right";

			const boundingClientRectTarget = target.getBoundingClientRect();
			const x = boundingClientRectTarget.x;
			const y = boundingClientRectTarget.y;

			xValue = x;
			yValue = y + boundingClientRectTarget.height;
		}
	}

	const { component, target, options, close } = usePopper();

	target.subscribe(async (target) => {
		if (target) {
			await tick();
			calculatePosition(target);
		}
	});
</script>

<svelte:window
	on:click={(event) => {
		if (!$popperRef?.contains(event.target as Node)) {
			close();
		}
		if ($options.closeOnContentClick) {
			if ($popperRef?.contains(event.target as Node)) {
				close();
			}
		}
	}}
/>
{#if $component}
	<div
		transition:fade={{ duration: 200 }}
		style="transform: translateX({xValue}px) translateY({yValue}px);"
		class="absolute left-0 top-0 z-[1001] flex
		
			
		"
		bind:this={$popperRef}
	>
		<div class="relative z-50 flex h-full w-full flex-col">
			<div
				class="flexabsolute shadow-primary-500 z-50 hidden h-2 w-full rounded-2xl shadow-lg sm:block
			
				{$popperPosition === 'left' && '!right-0 !h-full !w-2'}
				{$popperPosition === 'right' && '!left-0 !h-full !w-2'}
				{$popperPosition === 'bottom' ? 'top-0 ' : 'bottom-0 '}

			"
			></div>

			<svelte:component this={$component} />
		</div>
	</div>
{/if}
